import React from 'react';
import styled from 'styled-components';

import { FULL_VH } from 'components/Common';
import i18n from 'i18n';

const ErrorContainer = styled.div`
  background: white;
  height: calc(${FULL_VH}px - ${({ theme }) => theme.marginTop});
  word-wrap: break-word;
  width: 100vw;
  &:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }
  > div {
    display: inline-block;
    max-width: calc(100% - 20px);
    padding: 10px;
    text-align: center;
    vertical-align: middle;
  }
`;

export default ({ children }) => (
  <ErrorContainer>
    <div>
      <div>{i18n('component.ErrorPage.commonErrorText')()}</div>
      <div>{children}</div>
    </div>
  </ErrorContainer>
);
